'use client';

import type { FC } from 'react';
import { List } from '../../components/ui';
import { ReferralItemSkeleton } from './ReferralItemSkeleton';

export const ReferralsSkeleton: FC = () => (
  <div className="px-4">
    <List>
      {Array.from({ length: 10 }).map((_, i) => (
        <ReferralItemSkeleton key={i} />
      ))}
    </List>
  </div>
);
